/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step1_NameInputs */

const en_dr_step1_name = /** @type {(inputs: Dr_Step1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 · Problem`)
};

const id_dr_step1_name = /** @type {(inputs: Dr_Step1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 · Masalah`)
};

/**
* | output |
* | --- |
* | "1 · Problem" |
*
* @param {Dr_Step1_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step1_name = /** @type {((inputs?: Dr_Step1_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step1_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step1_name(inputs)
	return en_dr_step1_name(inputs)
});